import React from "react";
import { useEffect, useState } from "react";
import Chart from "../../common/ApexChart";
import Loader from "../../common/Loader";
import allApi from "../../../../api/allApi";
import { useLocalization } from "../../localization/LocalizationContext";
import { useNetwork } from "../../common/networkContext";

function WiredPowerExpansion() {
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [poeNetworkId, setPoeNetworkId] = useState("");
  const [networkIds, setNetworkIds] = useState([]);
  const [refreshing, setRefreshing] = useState(true);

  // useEffect(() => {
  //   fetchNetworkIds();
  // }, []);

  // useEffect(() => {
  //   if (networkIds.length > 0) {
  //     setPoeNetworkId(networkIds[0].network_id);
  //   }
  // }, [networkIds]);

  // const fetchNetworkIds = async () => {
  //   try {
  //     const api = new allApi();
  //     const response = await api.getRequest("api/network/allNetwork");
  //     if (
  //       response &&
  //       response.status === "OK" &&
  //       Array.isArray(response.response)
  //     ) {
  //       setNetworkIds(response.response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching network IDs:", error);
  //   }
  // };

  useEffect(() => {
    getPoeUsage(networkId);
  }, [networkId]);

  const getPoeUsage = async (networkId) => {
    try {
      setLoading(true);
      setRefreshing(true);
      const api = new allApi();
      const poeData = await api.getRequest(
        `api/wired/dashboard/poeUsage?networkId=${networkId}`
      );

      if (poeData && poeData.success && Array.isArray(poeData.success)) {
        const seriesData = poeData.success.map((item) => ({
          x: item.serialNo,
          y: item.poe,
          z: item.total_power,
        }));

        setSeries([{ data: seriesData }]);

        // Handle failure cases if needed
        if (poeData.failure && Array.isArray(poeData.failure)) {
          console.warn("Failed serial numbers:", poeData.failure);
        }
      } else {
        console.error("Unexpected poeData format:", poeData);
      }
    } catch (error) {
      console.error("Error fetching POE usage", error);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const poeOptions = {
    chart: {
      type: "bar",
      height: 135,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
    },
    yaxis: {
      title: {
        text: "Power Usage",
      },
      labels: {
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
    },
    tooltip: {
      //shared: true,
      intersect: false,
      x: {
        show: true,
      },
      y: {
        formatter: function (value) {
          return `POE: ${value} `;
        },
      },
      z: {
        title: "Total Power: ",
        formatter: function (value) {
          return `${value} W`;
        },
      },
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>{localizationStrings?.powerUsage}</h3>
            <div className="inc-card-button">
              {/* <div className="dropdown">
                <span
                  className="dropdown-toggle"
                  id="clientDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: "pointer" }}
                >
                  {poeNetworkId ? `Network: ${poeNetworkId}` : "Select Network"}
                </span>

                <ul className="dropdown-menu" aria-labelledby="clientDropdown">
                  {networkIds.map((net) => (
                    <li key={net.network_id}>
                      <button
                        className="dropdown-item"
                        onClick={() => setPoeNetworkId(net.network_id)}
                      >
                        {net.network_name || net.network_id}
                      </button>
                    </li>
                  ))}
                </ul>
              </div> */}
              {/* <input className="list-search" type="text" /> */}
              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => getPoeUsage(poeNetworkId)}
              >
                {refreshing ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                )}
              </button>
              {/* <button className="icon-btn" title="Filter">
                <i className="fa fa-filter" aria-hidden="true"></i>
              </button> */}
            </div>
          </div>
          <div className="inc-card-body">
            <div className="row">
              <div className="col-lg-8">
                <div className="inc-card-body">
                  {loading ? (
                    <Loader />
                  ) : (
                    <div>
                      {series.length === 0 || !series[0].data.length ? (
                        <div className="no-data-box">
                          <div className="no-data-text">
                            {localizationStrings?.noData}
                          </div>
                        </div>
                      ) : (
                        <Chart
                          options={poeOptions}
                          series={series}
                          type="bar"
                          height={250}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="round-border">
                  <div className="inc-card-table">
                    <table className="m-head">
                      <thead>
                        <tr>
                          <th>{localizationStrings?.serialNumber}</th>
                          <th>{localizationStrings?.poeUsage}</th>
                          <th>{localizationStrings?.totalPower}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {series &&
                          series.length > 0 &&
                          series[0].data &&
                          series[0].data.map((item, index) => (
                            <tr key={index}>
                              <td>{item.x}</td>
                              <td>{item.y}</td>
                              <td>{item.z}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WiredPowerExpansion;
